// Stable partition: do not change relative order within either group.
export const jockeyFirst = (rows, description = row => row.pumpDescription) => [
  ...rows.filter(row => String(description(row) || '').trim().toLowerCase() === 'jockey'),
  ...rows.filter(row => String(description(row) || '').trim().toLowerCase() !== 'jockey'),
];
